export const STRAPI_API = process.env.REACT_APP_STRAPI_API
export const STRAPI_API_REQ = STRAPI_API + "/graphql"
